import { PortalBaseService } from 'src/portal/portal-base.service';
import { Injectable } from '@angular/core';
import { BehaviorSubject, lastValueFrom } from 'rxjs';
import { PersonApplication } from 'src/app/shared/models/application/personApplication';

@Injectable({
  providedIn: 'root'
})
export class PortalFormService extends PortalBaseService {
  private baseUsersPath: string = 'v0.1/users';

  constructor() {
    super();
  }

  private usersBaseUrl(userId: string) {
    return `${this.baseUsersPath}/${userId}`;
  }

  private getApplicationsUrl(userId: string) {
    return this.usersBaseUrl(userId).concat('/applications');
  }

  private convertApplications(data): PersonApplication[] {
    return data.map((application) => PersonApplication.parse(application));
  }

  getForms(userId: string): Promise<PersonApplication[]> {
    const url = this.getApplicationsUrl(userId);

    return lastValueFrom(this.get(url, true)).then(this.convertApplications);
  }
}
